module.exports = __webpack_public_path__ + "img/icon_map_6_on_010.29470a6a.png";